import { MenuItem, TextField, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { WorkStationTypes } from "../../../helper/workStationHelper";

const SelectWorkStationType = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <TextField select variant="outlined" {...props}>
      {WorkStationTypes.map((workStationType, index) => {
        return (
          <MenuItem key={index} value={workStationType}>
            {workStationType}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default SelectWorkStationType;
